<template>
    <div class="ss">
        <div
            v-if="shippingAddress.ZipCode"
            class="ss__container ss__container--shipping"
        >
            <h2 class="ss__title" v-text="$ml.get('deliveryAddress')" tabindex="0" />
            <p class="ss__text ss__text--shipping" tabindex="0">
                <span>{{ shippingAddress.ZipCode }} - </span>
                <span>{{ shippingAddress.Street }}, </span>
                <span>{{ shippingAddress.Number }} </span>
                <span>{{ shippingAddress.District }} </span>
                <span>{{ shippingAddress.City }} - </span>
                <span>{{ shippingAddress.State }} </span>
                <span v-if="shippingAddress.Complement">- {{ shippingAddress.Complement }}</span>
            </p>
        </div>

        <div class="ss__container ss__container--cart">
            <h2 class="ss__title" v-text="$ml.get('paymentSummary')" tabindex="0" />

            <div class="cart-item" :key="key" v-for="(item, key) in cartItems" tabindex="0">
                <span :title="item.name" class="cart-item__name">({{ item.quantity }}) {{ item.name }}</span>
                <span class="cart-item__price">{{ formatPrice(item.unitPrice * item.quantity ) }}</span>
            </div>

            <button v-if="hiddenItems > 0 & !shouldShowAllItems" @click="showAllItems" class="show-all" :aria-label="$ml.get('ariaSeeAllItems')">
                <span v-text="shouldShowAllItems ? $ml.get('hideItems') : $ml.get('seeAllItems')" />
                <img :class="{ active: shouldShowAllItems }" src="@/assets/img/icons/arrow-down-blue.svg" alt="" tabindex="-1" />
            </button>

            <p class="ss__method" v-if="method.Type !== 'WithoutShipping'">
                <span> {{ method.Description }} </span>
                <span v-if="method.Price != 0">{{ formatPrice(method.Price) }}</span>
                <span v-if="method.Price == 0" class="free" v-text="$ml.get('free')" />
            </p>

            <p class="ss__discount" v-if="cartDiscount.DiscountPrice">
                <!-- <span>{{ $ml.get('cartDiscount') + ' : ' + cartDiscount.DiscountPercentage + '%' }}</span> -->
                <span v-text="$ml.get('cartDiscount')" />
                <span class="price">{{ `- ` + formatPrice(cartDiscount.DiscountPrice) }}</span>
            </p>

            <strong class="ss__total-price">
                <span v-text="$ml.get('totalAmount')" />
                <span v-text="formatPrice(totalPrice)" />
            </strong>
        </div>

        
        <div
            v-if="productDescription"
            class="ss__container ss__container--description"
        >
            <CartItemDescription
                :item-description="productDescription"
                :is-short-description="false"
                custom-class="order-status"
            />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import CartItemDescription from '@/components/CartItemDescription';
    import moneyHelper from '@/helpers/moneyHelper';

    export default {
        data() {
          return {
              shouldShowAllItems: true,
              itemsToPreview: 2
          };
        },

        props: {},

        components: {
            CartItemDescription,
        },
        
        computed: {
            ...mapGetters({
                shippingAddress: 'orderStatus/getShippingAddress',
                productDescription: 'orderStatus/getFirstItemDescription',
                shoppingCartItems: 'orderStatus/getShoppingCartItems',
                method: 'orderStatus/getShippingMethod',
                totalPrice: 'orderStatus/getTotalPrice',
                cartDiscount: 'orderStatus/getCartDiscount',
            }),

            cartItems() {
                if (this.shouldShowAllItems)
                    return this.shoppingCartItems;

                return this.shoppingCartItems.slice(0, this.itemsToPreview);
            },

            hiddenItems() {
                let hiddenItems = this.shoppingCartItems.length - this.itemsToPreview;

                return (hiddenItems > 0) ? hiddenItems : 0;
            }
        },

        methods: {
            showAllItems() { 
                this.shouldShowAllItems = !this.shouldShowAllItems;
            },

            formatPrice(unitPrice) {
                let totalPrice = unitPrice / 100; // Transforma centavos em real.

                return `R$ ${moneyHelper.formatToPrice(totalPrice)}`;
            }
        },

    };
</script>

<style lang="scss" scoped>
  .ss {
      margin-bottom: 32px;

      &__container {
          &:not(:last-child) {
              margin-bottom: 32px;
          }

          &--shipping {}

          &--cart {
              .cart-item {
                  display: flex;
                  justify-content: space-between;
                  font-size: 16px;
                  font-weight: 500;
                  line-height: 11px;
                  color: #5C6A7B;

                  &:not(:last-of-type) {
                      margin-bottom: 16px;
                  }

                  &__name {}

                  &__price {}

              }
              .show-all {
                  //btn reset
                  background: none;
                  border: none;
                  margin: 16px 0 0;
                  padding: 0;
                  cursor: pointer;

                  span {
                      font-size: 16px;
                      font-weight: 700;
                      line-height: 24px;
                      color: #0667CD;
                      text-decoration: underline;
                  }

                  img {
                      margin-left: 8px;
                      &.active {
                          transform: rotate(180deg);
                      }
                  }
              }
              .ss__title {
                  margin-bottom: 16px;
              }
          }

          &--description {}
      }

      &__title {
          font-size: 16px;
          font-weight: 700;
          line-height: 11px;
          color: #2F363E;
          margin-bottom: 8px;
      }

      &__text {
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          color: #5C6A7B;
          margin: 0;
      }

      &__method {
          display: flex;
          justify-content: space-between;
          font-size: 16px;
          font-weight: 500;
          color: #5C6A7B;
          line-height: 11px;
          margin: 16px 0 0;

          .method-description {}

          .method-price {
              &.free {
              }
          }
      }

      &__discount {
          display: flex;
          justify-content: space-between;
          font-size: 16px;
          font-weight: 500;
          color: #5C6A7B;
          line-height: 11px;
          margin: 16px 0 0;

          .price {
              color: #00855D;
          }
      }

      &__total-price {
          display: flex;
          justify-content: space-between;
          font-size: 16px;
          color: #2F363E;
          line-height: 11px;
          margin: 16px 0 0;
      }
  }
</style>
